import {
  ChangeDetectorRef,
  Component,
  DoCheck,
  EventEmitter,
  Input,
  IterableDiffer,
  IterableDiffers,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { ComboBoxOption } from 'src/app/models/combo-box-option';
import { Product } from 'src/app/models/register/product/product';
import { ProductDistribution } from 'src/app/models/register/product/product-distribution';
import { ProductDistributionDetail } from 'src/app/models/register/product/product-distribution-detail';
import { FileService } from 'src/app/services/file/file.service';
import { ProductService } from 'src/app/services/product/product.service';
import { WorkBook, WorkSheet } from 'xlsx';

@Component({
  selector: 'distribution-automatic',
  templateUrl: './distribution-automatic.component.html',
  styleUrls: ['./distribution-automatic.component.scss'],
})
export class DistributionAutomaticComponent implements OnChanges, DoCheck, OnInit {
  printBatchRestrictedPrefix: string = '';

  @ViewChild('deliveryWayAutomaticInput')
  deliveryWayAutomaticInput: FileUpload | null = null;

  @Input()
  InputdeliveryWayAutomatic: ProductDistribution[] = [];

  selectedDistribution!: ProductDistribution[];

  deliveryWayAutomatic: any[] = [];

  @Input()
  quantity: string = '0';

  @Input()
  isConfirmed: boolean = false;

  @Input()
  isLoading: boolean = false;

  printBatchRestrictedPrefixOptions: ComboBoxOption[] = [];

  @Output()
  changeTotal = new EventEmitter<any>();

  @Input()
  totalValue: number = 0;

  currentTotal: number = 0;

  @Output()
  changed = new EventEmitter<any>();

  private differ: IterableDiffer<ProductDistribution>;

  constructor(
    private productService: ProductService,
    private confirmationService: ConfirmationService,
    private differs: IterableDiffers,
    private cdr: ChangeDetectorRef
  ) {
    this.differ = this.differs.find([]).create<ProductDistribution>();
  }

  ngOnInit(): void {
    this.currentTotal = this.totalValue;
    this.InputdeliveryWayAutomatic.forEach(item => {
      this.deliveryWayAutomatic.push(item);
    });
  }

  public download(url: string): void {
    window.location.href = url;
  }

  handleParsedData(data: { branchCode: string; quantity: number }[]) {
    console.log('Dados recebidos da planilha:', data);

    data.forEach(({ branchCode, quantity }) => {
      this.productService
        .combobox('branches', branchCode)
        .then((resultData: any): void => {
          if (resultData?.length) {
            this.deliveryWayAutomatic.push({
              detail: {
                id: resultData[0].value,
                label: resultData[0].label,
              },
              quantity,
              checked: true,
            });
          }
        })
        .finally(() => this.onChangeData());
    });
  }

  public removeDeliveryWayAutomatic(event: any, item: any, i: number): void {
    this.confirmationService.confirm({
      target: event.target!,
      header: 'Confirmação',
      message: 'Deseja realmente remover <strong>' + item.detail.label + '</strong>?',
      icon: 'fa-solid fa-exclamation-triangle',
      acceptLabel: 'Sim',
      acceptButtonStyleClass: 'p-button-danger',
      rejectLabel: 'Não',
      defaultFocus: 'reject',
      accept: (): void => {
        this.setOnRemoveItem(i);
      },
      reject: (): void => {
        // reject action
      },
    });
  }

  public deliveryWayCanBeRemoved(item: any): boolean {
    return item.orderItem === undefined || item.orderItem === null || item.orderItem < 1;
  }

  public filterDeliveryWayAutomatic(event: any): void {
    this.productService
      .combobox('branches', event.query) //
      .then(
        (data: any): void =>
          (this.printBatchRestrictedPrefixOptions = data.filter(
            (item: any): boolean =>
              !this.deliveryWayAutomatic.some(
                (distribution: any): boolean => distribution['id'] === item['value']
              )
          ))
      );
  }

  public addDeliveryWayAutomatic(event: any): void {
    this.deliveryWayAutomatic.push({
      detail: {
        id: event.value,
        label: event.label,
      } as ProductDistributionDetail,
      quantity: 0,
    } as ProductDistribution);

    setTimeout((): void => {
      this.printBatchRestrictedPrefix = '';
      const input: HTMLInputElement = document.getElementById(
        'print-batch-restricted-prefix1'
      )! as HTMLInputElement;
    }, 100);
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes);
  }

  public deleteSelectedProductionItens(event: any) {
    this.confirmationService.confirm({
      target: event.target!,
      header: 'Confirmação',
      message: `Deseja remover ${this.selectedDistribution.length} linhas da distribuição?`,
      icon: 'fa-solid fa-exclamation-triangle',
      acceptLabel: 'Sim',
      acceptButtonStyleClass: 'p-button-danger',
      rejectLabel: 'Não',
      defaultFocus: 'reject',
      accept: (): void => {
        this.selectedDistribution.forEach(item => {
          var idx = this.deliveryWayAutomatic.findIndex(
            deliveryItem => deliveryItem.id === item.id
          );
          this.setOnRemoveItem(idx);
        });
      },
      reject: (): void => {
        // reject action
      },
    });
  }

  private setOnRemoveItem(index: number) {
    this.deliveryWayAutomatic[index].remove = true;
    this.onChangeData();
  }

  ngDoCheck(): void {
    const change = this.differ.diff(this.deliveryWayAutomatic);
    if (change) {
      // há mudanças internas no array
      change.forEachAddedItem(record => {
        // console.log('Item adicionado:', record.item);
      });
      change.forEachRemovedItem(record => {
        // console.log('Item removido:', record.item);
      });

      this.cdr.detectChanges();
    }
  }

  get Itens() {
    return this.deliveryWayAutomatic.filter((item: any) => !item.remove);
  }

  onChangeData(): void {
    console.log(this.deliveryWayAutomatic);
    this.changed.emit(this.deliveryWayAutomatic);
  }

  onChangeTotal(): void {
    console.log('changed this total');
    this.changeTotal.emit({ type: 'A', total: this.currentTotal });
  }
}
